<template>
  <v-dialog fullscreen v-model="dialog" max-width="1500">
    <v-card>
      <v-card-title class="border-bottom">
        Stok Hareketleri - {{ this.currentProp ? this.currentProp.code + ' ' + this.currentProp.name : '' }}
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="py-3 d-flex">
          <div>
            <PrintPage :divId="'currentStockActionsPrint'"></PrintPage>
            <ExcelExport
                :dataProp="currentStockActionList"
                :columnProp="currentStockActionListHeaders"
                :fileNameProp="this.currentProp ? 'Cari Stok Hareketleri ' + this.currentProp.code + ' ' + this.currentProp.name : ''"
            >

            </ExcelExport>

          </div>
          <div class="d-flex ms-auto">
              <v-select
                  class="me-5"
                v-model="reportDbName"
                placeholder="Tüm Şirketler"
                clearable
                solo
                filled
                dense
                :items="companyList"
                :item-text="item => item.name"
                :item-value="item => item.name"
            >
            </v-select>
              <v-text-field
                v-model="searchText"
                class="pt-1"
                outlined
                rounded
                dense
                placeholder="Arama Yapın..."
                clearable
                hide-details
                append-icon="mdi-magnify"
                @click:append="searchListWithText()"
                @keydown.enter="searchListWithText()"
            >
            </v-text-field>
          </div>
        </div>
        <div>
          <b-table
              :items="currentStockActionList"
              :fields="currentStockActionListHeaders"
              hover
              small
              responsive
              sort-icon-left
              :busy="currentStockActionListLoading"
              id="currentStockActionsPrint"
              head-row-variant="info"
              table-variant="white"
              show-empty
          >
            <template #empty="scope">
              <h6 class="text-center my-5">
                {{ scope.loading ? "Lütfen Bekleyin" : noStockMessage ? noStockMessage : "Veri Bulunamadı" }}
              </h6>
            </template>
            <template #cell(actionDate)="data">
              {{ formattedDate(data.item.actionDate, "DD-MM-YYYY") }}
            </template>
            <template #cell(actionType)="data">
              {{ data.item.actionType === 1 ? 'Satış' : 'Alış' }}
            </template>
            <template #cell(unitPrice)="data">
              {{ user.RoleGroupId !== "1" || user.RoleGroupId === 1 && data.item.actionType === 2 ? '-' : data.item.unitPrice }}
            </template>
            <template #cell(quantity)="data">
              {{ numberConverter(data.item.quantity) }}
            </template>
            <template #table-busy>
              <div class="text-center">
                <b-spinner
                    variant="primary"
                    size="lg"
                    label="Lütfen Bekleyin..."
                ></b-spinner>
              </div>
            </template>
            <template #cell(currencyType)="data">
              {{ fetchCurrencyLabel(data.item.currencyType)}}
            </template>
          </b-table>
        </div>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions, mapState, mapMutations, mapGetters} from 'vuex';
import {formattedDate} from "@/momentHelper";
import {numberConverter, printView} from "../../../../helpers";
import ExcelExport from "@/components/shared/ExcelExport";
import PrintPage from "@/components/shared/PrintPage";

export default {
  name: "CurrentStockActionsDialog",
  components: {
    ExcelExport,
    PrintPage
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    currentProp: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapState("dashboard", ["errorMessageAll"]),
    ...mapState("stock", ["currentStockActionList", "currentStockActionListHeaders", "currentStockActionListLoading", "noStockMessage"]),
    ...mapState("auth", ["user"]),
    ...mapState("settings", ["erpSettings"]),
    ...mapGetters("settings", ["getCurrencyLabels"]),
    ...mapState("company", ["companyList"]),
    currencyLabels: {
      get() {
        return this.getCurrencyLabels;
      },
    },
  },
  data() {
    return {
      dialog: false,
      perPage: 10,
      currentPage: 1,
      searchText: "",
      reportDbName: null,
    };
  },
  methods: {
    ...mapActions("stock", ["fetchCurrentStockActionList"]),
    ...mapMutations("stock", ["setCurrentStockActionList"]),
    ...mapMutations("stock", ["setUseErpSettings"]),
    ...mapActions("company", ["fetchCompanyList"]),
    numberConverter,
    printView,
    formattedDate,
    closeDialog() {
      this.dialog = false;
      this.searchText = null;
    },
    fetchCurrencyLabel(currencyType) {
      for (const item of this.currencyLabels) {
        if (item.id === currencyType) {
          return item.label;
        }
      }
      return '';
    },
    async searchListWithText() {
      switch (this.user.RoleGroupId) {
        case "1":
          this.fetchCurrentStockActionList({
            params: {},
            body: {
              StockCode: null,
              CurrentCode: this.currentProp.code,
              ...(this.searchText == "" || this.searchText == null ? false : true) && {SearchText: this.searchText}
            }
          });
          break;
        case "2":
          this.fetchCurrentStockActionList({
            params: {},
            body: {
              SalesPersonCode: this.user.SalesPersonCode,
              StockCode: null,
              CurrentCode: this.currentProp.code,
              ...(this.searchText == "" || this.searchText == null ? false : true) && {SearchText: this.searchText}
            }
          });
          break;
      }
    },
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
      if (newVal)
        switch (this.user.RoleGroupId) {
          case "1":
            this.fetchCurrentStockActionList({
              params: {},
              body: {
                StockCode: null,
                CurrentCode: this.currentProp.code,
                ...(this.searchText == "" || this.searchText == null ? false : true) && {SearchText: this.searchText}
              }
            });
            break;
          case "2":
            this.fetchCurrentStockActionList({
              params: {},
              body: {
                SalesPersonCode: this.user.SalesPersonCode,
                StockCode: null,
                CurrentCode: this.currentProp.code,
                ...(this.searchText == "" || this.searchText == null ? false : true) && {SearchText: this.searchText}
              }
            });
            break;
        }
      else
        this.setCurrentStockActionList([])

    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    },
    reportDbName: function (newVal) {
      switch (this.user.RoleGroupId) {
        case "1":
          this.fetchCurrentStockActionList({
            params: {},
            body: {
              StockCode: null,
              CurrentCode: this.currentProp.code,
              ...(this.searchText == "" || this.searchText == null ? false : true) && {SearchText: this.searchText},
              reportDbName: newVal,
            }
          });
          break;
        case "2":
          this.fetchCurrentStockActionList({
            params: {},
            body: {
              SalesPersonCode: this.user.SalesPersonCode,
              StockCode: null,
              CurrentCode: this.currentProp.code,
              ...(this.searchText == "" || this.searchText == null ? false : true) && {SearchText: this.searchText},
              reportDbName: newVal,
            }
          });
          break;
      }
    }
  },
  mounted() {
    this.fetchCompanyList({
      params: {},
      body: {}
    });
  }
}
</script>

<style scoped>

</style>